import { WriteRecord } from '../../utils/WriteRecord';
import { IdManagerIfc } from '../id/IdManagerIfc';
import { BitBoardIdManager32 } from '../id/manager32/BitBoardIdManager32';
import { RecShapeIfc } from '../../shape/RecShapeIfc';
import { ConcreteSet, RecordUpdater } from './ConcreteSet';

export class ConcreteDriver {
    cSet:ConcreteSet;
    idManager:IdManagerIfc;
    destructed:boolean;
    
    constructor( cSet:ConcreteSet ) 
    {
        this.cSet = cSet;
        this.idManager = new BitBoardIdManager32();
    }
    
    public getCSet():ConcreteSet{
        return this.cSet;
    }
    
    public getShape():RecShapeIfc{
        return this.cSet.getShape();				
    }
    public destruct( destructCset:Boolean ):void{
        if( destructCset ){
            this.cSet.destruct();
        }
        this.idManager = null;
        this.cSet = null;
        this.destructed = true;
    }
    
    public createNewRecord():WriteRecord{
        var id:number = this.idManager.allocate();
        var newRecord:WriteRecord = new WriteRecord( this.getShape(), id );
        return newRecord;
    }
    
    public isDestructed():Boolean {
        return this.destructed;
    }

    public getRecord( id:number = -1 ):WriteRecord {
        if( id < 0 ){
            id = this.idManager.allocate();	
        }
        var rec:WriteRecord = this.cSet.getRecordUpdater(id);
        return rec;
    }
    
    public getUpdater( id:number ):RecordUpdater{
        return this.cSet.getRecordUpdater(id);
    }
    
    public addRecord( recordId:number ):void {
        if( !this.idManager.isAllocated( recordId ) ){
            this.idManager.allocateConcrete( recordId );
        }
        this.cSet.addRecord(recordId);
    }
    
    public addRecords( records:Array<number> ):void {
        for ( let id of records ){
            this.idManager.allocateConcrete( id );
        }
        this.cSet.addRecords(records);
    }
                
    public begin():void {
        this.cSet.begin();
    }
    
    public end():void {
        this.cSet.end();
    }
    
    public deleteRecord( id:number ):void {
        this.idManager.free(id);
        this.cSet.deleteRecord(id);
    }		
    
    public deleteRecords( ids:Array<number> ):void {
        for ( let id of ids){
            this.idManager.free(id);
        }
        this.cSet.deleteRecords(ids);		
    }
    public reset():void {
        this.idManager.reset();
        this.cSet.reset();
    }
    
    public removeMetaData( name:string ):void{
        this.cSet.removeMetaData(name);
    }
    public setContainerMetaData( name:string, value:string ):void{
        this.cSet.setContainerMetaData(name, value);
    }
    
    public setContainerMetaDatas( names:Array<string>, values:Array<string> ):void{
        this.cSet.setContainerMetaDatas(names, values);
    }
    public removeContainerMetaDatas( names:Array<string> ):void{
        this.cSet.removeContainerMetaDatas( names );
    }
}